"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
const useFormValidation = callback => {
  const [data, setData] = (0, _react.useState)({});
  const [errors, setErrors] = (0, _react.useState)({});
  const [isValid, setValidity] = (0, _react.useState)(true);
  const [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (isValid) {
      callback(data, isSubmitting);
      setIsSubmitting(false);
    }
  }, [callback, data, isSubmitting, isValid]);
  const handleData = (value, name) => {
    setIsSubmitting(false);
    const newData = {
      ...data
    };
    newData[name] = value;
    // setData(newData);
  };
  const handleError = error => {
    if (error.errors.length) {
      setIsSubmitting(false);
      errors[error.name] = error.errors;
    } else {
      delete errors[error.name];
    }
    setErrors(errors);
    setValidity(Object.keys(errors).length === 0);
  };
  const handleValidation = {
    onChange: (value, name) => handleData(value, name),
    onError: error => handleError(error)
  };
  const handleSubmit = (event, dataToSubmit, errorsToDisplay) => {
    event.persist();
    event.preventDefault();
    setIsSubmitting(true);
    // console.log('handleSubmit');
    setData(dataToSubmit);
    setErrors(errorsToDisplay);
    setValidity(Object.keys(errorsToDisplay).length > 0);

    // Trigger each element to validate
    // There is probably a better way of doing it
    [...event.target.elements].forEach(element => {
      element.focus();
    });
  };
  return [data, errors, isValid, {
    handleData,
    handleError,
    handleValidation,
    handleSubmit
  }];
};
var _default = exports.default = useFormValidation;